import React, { useContext, useState } from "react";
import styled from "styled-components";
import ProductsMenuView from "./ProductsMenuView";
import ProductListProcessor from "../../../Views/ProductListProcessor";
import MyProductsView from "./MyProductsView";
import WorkspaceContext from "../../WorkspaceContext";
import { isCartazFormat } from "../../../../services/Utils";
const TabsWrapper = styled.div`
  width: 100%;
`;

const TabsHeader = styled.div`
  display: flex;
  gap: 0.8rem;
  margin-bottom: 1.2rem;
`;

const TabButton = styled.button`
  all: unset;
  cursor: pointer;
  padding: 0.8rem 1.2rem;
  border-radius: 6px;
  border: 1px solid #ffffff;
  font-size: 1.4rem;
  font-weight: 600;
  text-transform: uppercase;
  background-color: ${({ $isActive }) =>
    $isActive ? "#d97706" : "transparent"};
  color: #ffffff;
`;

export default function ProductMenuTab({ props }) {
  const [activeTab, setActiveTab] = useState("Encarte");
  const { styles } = useContext(WorkspaceContext);
  return (
    <TabsWrapper>
      <TabsHeader>
        <TabButton
          $isActive={activeTab === "Encarte"}
          onClick={() => setActiveTab("Encarte")}
        >
          Produtos {isCartazFormat(styles?.format) ? "Cartaz" : "Encarte"}
        </TabButton>
        <TabButton
          $isActive={activeTab === "List"}
          onClick={() => setActiveTab("List")}
        >
          Enviar Lista
        </TabButton>
        <TabButton
          $isActive={activeTab === "Cadastrados"}
          onClick={() => setActiveTab("Cadastrados")}
        >
          Meus Produtos
        </TabButton>
      </TabsHeader>

      {activeTab === "Encarte" ? (
        <ProductsMenuView props={props} />
      ) : activeTab === "List" ? (
        <ProductListProcessor />
      ) : (
        <MyProductsView />
      )}
    </TabsWrapper>
  );
}
